import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { readableColor } from "polished";
import { StyledNavigationTab, StyledNavigationTabIconContainer } from "../../../navigation/NavigationTabs";

export const NavigationContainer = styled.div`
    padding: 1rem 1rem 0 1rem;
    color: ${props => readableColor(props.theme.primary, props.theme.dark, props.theme.light)};
    background-color: ${(props: any) => props.theme.secondary};
`;

export const NavigationTab = React.forwardRef(({ icon, label, ...rest }: any, ref) => (
    <StyledNavigationTab ref={ref} {...rest}>
        <StyledNavigationTabIconContainer>
            <FontAwesomeIcon icon={icon} />
        </StyledNavigationTabIconContainer>
        <span>{label}</span>
    </StyledNavigationTab>
));